<template>
    <div class="content_box mobile_content">
        <div class="content knowledge">
            <div class="title_box">
                <div class="title">
                    <span>产品分类</span>
                </div>
            </div>
            <div class="knowledge_box">
                <div class="knowledge" :class="'knowledge' + ((i + 1)%6 == 0 ? 6 : i%6 + 1)" v-for="(item, i) in knowledge" :key="item.product_id" @click="goFaq(item)">
                    <p>{{item.product_name}}</p>
                    <div class="popover_box" @click="popoverClick" v-if="roleCheck('101-104-101-102') && roleCheck('101-104-101-103')">
                        <el-popover
                            popper-class="popover"
                            placement="bottom-start"
                            width="80"
                            trigger="hover">
                            <div class="act_box">
                                <p @click="rename(item)" v-if="roleCheck('101-104-101-102')">重命名</p>
                                <div class="line" v-if="roleCheck('101-104-101-102')"></div>
                                <p @click="delKnowledge(item)" v-if="roleCheck('101-104-101-103')">删除分类</p>
                            </div>
                            <img class="more-act" src="../../../assets/images/knowledge/more.png" slot="reference" alt="">
                        </el-popover>
                    </div>
                </div>
                <div class="knowledge add" @click="addCate" v-if="roleCheck('101-104-101-102')">
                    <div>
                        <img src="../../../assets/images/knowledge/add.png" alt="">
                        <p>添加产品分类</p>
                    </div>
                </div>
            </div>
            <Tip ref="tip" :msg="tipMsg" @tipBack="delConfirm"></Tip>
            <Gh-Dialog ref="dislog" :title="dislog.title" @dialogBack="confirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule">
                        <el-form-item label="产品分类:" prop="product_name">
                            <el-input v-model="actData.product_name" maxlength="10" placeholder="请输入产品分类名称"></el-input>
                        </el-form-item>
                        <el-form-item label="英文缩写:" prop="product_en" >
                            <el-input v-model="actData.product_en" maxlength="2"  placeholder="请输入2位大写英文字母"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
    
</template>
<script>
export default({
    name: 'knowledge',
    data() {
        return {
            knowledge: [],
            actData: {
                product_id: '',
                product_name: '',
                product_en: ''
            },
            tipMsg: '',
            dislog: {},
            formRule: {
                product_en:[
                    { required: true, message: '请输入2位大写英文字母', trigger: 'blur' },
                    {required: true, message: '请输入2位英文字母', trigger: 'blur', pattern: /^[A-Za-z][A-Za-z]$/, type:'string'}
                ],
                product_name: [
                    { required: true, message: '请输入产品分类名称', trigger: 'blur' },
                ]
            }
        }
    },
    watch: {
        'actData.product_en': function(nN) {
            nN = nN.replace(/[^\w]/g,'');
            this.actData.product_en = nN.toUpperCase()
        }
    },
    created() {
        this.getProductCate();
    },
    mounted() {
       
    },
    methods: {
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.knowledge = data.data.productCateInfos;
            })
        },
        rename(item) {
            this.actData = {
                product_id: item.product_id,
                product_name: item.product_name,
                product_en: item.product_en
            };
            this.dislog = {
                title: '重命名',
                type: 'rename'
            };
            this.$refs.dislog.show = true;
        },
        delKnowledge(item) {
            this.actData = {
                product_id: item.product_id,
                product_name: item.product_name,
                product_en: item.product_en
            };
            this.api.tryDelProductCate({product_id: item.product_id}).then(r => {
                if(r.data.is_del) {
                    this.tipMsg = '确认删除产品分类-' + item.product_name + '吗，删除后不能再恢复哦！';
                    this.$refs.tip.show = true;
                }else{
                    this.$message.warning('当前产品分类下有正在使用的问题，暂不能删除!');
                }
                
            })
        },
        delConfirm() {
            this.api.deleteProductCate({product_id: this.actData.product_id}).then(data => {
                this.getProductCate();
                this.$message.success('删除成功！');
                this.$refs.tip.show = false;
            })
        },
        goFaq(item) {
            this.$router.push({name: 'faq', params: {id: item.product_id}, query:{title: item.product_name, productTypes: item.productTypes.join('/')}});
        },
        popoverClick(e) {
            e.stopPropagation();
        },
        addCate() {
            this.actData = {
                product_name: '',
                product_en: ''
            };
            this.dislog = {
                title: '添加产品分类',
                type: 'add'
            };
            this.$refs.dislog.show = true;
        },
        confirm() {
            this.$refs.formRule.validate(v => {
                if(v){
                    if(this.dislog.type == 'add') {
                        this.api.createProductCate(this.actData).then(data => {
                            this.getProductCate();
                            this.$refs.dislog.show = false;
                            this.$message.success('添加成功!');
                            
                        })
                    }else if(this.dislog.type == 'rename') {
                        this.api.updateProductCate(this.actData).then(data => {
                            this.getProductCate();
                            this.$refs.dislog.show = false;
                            this.$message.success('修改成功!');
                            
                        })
                    }
                }
            });
            
        }
    }
})
</script>
<style lang="less" scoped>
    .title{
        margin-bottom: 20px;
    }
    .knowledge_box{
        .flexLayout(flex-start, flex-start);
        .knowledge{
            text-align: center;
            position: relative;
            width: 300px;
            height: 140px;
            padding: 0 10px;
            margin-right: 60px;
            margin-bottom: 40px;
            font-size: 20px;
            color: #fff;
            cursor: pointer;
            .flexLayout();
            .popover_box{
                position: absolute;
                bottom: 10px;
                right: 10px;
                .more-act{
                    width: 28px;
                }
            }
            
            &.add{
                color: #000;
                text-align: center;
                background: #EDF5FD;
                border-radius: 18px;
                img{
                    display: inline-block;
                    width: 30px;
                }
                p{
                    font-size: 16px;
                    color: #868998;
                    margin-top: 10px;
                }
            }
            &.knowledge1 {
                background: url('../../../assets/images/knowledge/knowledge1.png') no-repeat;
                background-size: 100% 100%;
            }
            &.knowledge2 {
                background: url('../../../assets/images/knowledge/knowledge2.png') no-repeat;
                background-size: 100% 100%;
            }
            &.knowledge3 {
                background: url('../../../assets/images/knowledge/knowledge3.png') no-repeat;
                background-size: 100% 100%;
            }
            &.knowledge4 {
                background: url('../../../assets/images/knowledge/knowledge4.png') no-repeat;
                background-size: 100% 100%;
            }
            &.knowledge5 {
                background: url('../../../assets/images/knowledge/knowledge5.png') no-repeat;
                background-size: 100% 100%;
            }
            &.knowledge6{
                background: url('../../../assets/images/knowledge/knowledge6.png') no-repeat;
                background-size: 100% 100%;
            }
        }
        @media (max-width: 768px) {
            .knowledge{
                width: 100%;
                height: 80px;
                margin-right: 0;
                margin-bottom: 20px;
                padding: 0 20px;
                font-size: 16px;
                justify-content: space-between;
                .popover_box{
                    position: static;
                }
                &.add{
                    justify-content: center;
                    div{
                        .flexLayout();
                        img{
                            width: 20px;
                        }
                        p{
                            margin: 0 0 0 10px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/order/knowledge/knowledge.vue